import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAliexpressComponent } from './simple-icons-aliexpress.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAliexpressComponent ],
    exports:      [ SimpleIconsAliexpressComponent ],
    bootstrap:    []
})
export class SimpleIconsAliexpressModule {}
